import { useEffect } from 'react';

export const useUnmount = (callback) => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => callback, []);
};
